// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table_shnzj [role="cell"]:nth-child(odd) {
  background-color: var(--color-base025);
}

.table_shnzj [role="cell"]:nth-child(1),.table_shnzj [role="cell"]:nth-child(2) {
  background-color: white;
}

.table_shnzj [role="cell"]:nth-child(1) {
  z-index: 10 !important;
}

.table_shnzj [role="cell"][data-sticky-last-left-td="true"] {
  -webkit-box-shadow: 2px 6px 13px -3px rgba(0,0,0,0.42);
  -moz-box-shadow: 2px 6px 13px -3px rgba(0,0,0,0.42);
  box-shadow: 2px 6px 13px -3px rgba(0,0,0,0.42);
}`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/alerts/components/AlertsTable.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sDAAsD;EACtD,mDAAmD;EACnD,8CAA8C;AAChD","sourcesContent":[".table [role=\"cell\"]:nth-child(odd) {\n  background-color: var(--color-base025);\n}\n\n.table [role=\"cell\"]:nth-child(1),.table [role=\"cell\"]:nth-child(2) {\n  background-color: white;\n}\n\n.table [role=\"cell\"]:nth-child(1) {\n  z-index: 10 !important;\n}\n\n.table [role=\"cell\"][data-sticky-last-left-td=\"true\"] {\n  -webkit-box-shadow: 2px 6px 13px -3px rgba(0,0,0,0.42);\n  -moz-box-shadow: 2px 6px 13px -3px rgba(0,0,0,0.42);\n  box-shadow: 2px 6px 13px -3px rgba(0,0,0,0.42);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `table_shnzj`
};
export default ___CSS_LOADER_EXPORT___;
